/**
 * Dashboard list rows: optional groups listContext, feedOverrides, display,
 * interactions, external, sectionMeta — omit unused groups; item components default each to {}.
 * external — widget / embed-specific (not the ListItem `embed` boolean).
 */

export function flattenListRowProps(listRow) {
  if (listRow == null || typeof listRow !== 'object') {
    return {};
  }
  const {
    listContext = {},
    feedOverrides = {},
    display = {},
    interactions = {},
    external = {},
    sectionMeta = {},
  } = listRow;
  return {
    ...listContext,
    ...feedOverrides,
    ...display,
    ...interactions,
    ...external,
    ...sectionMeta,
  };
}
